import { Component, OnInit } from '@angular/core';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { BrandService } from '../../../../../../services/brand.service';

@Component({
    selector: 'app-mmlanding-footer',
    templateUrl: './mmlanding-footer.component.html',
    styleUrls: ['./mmlanding-footer.component.scss'],
    standalone: false
})
export class MMLandingFooterComponent implements OnInit {
	public officeStatus: OfficeStatus;
	public currentYear: number = 2023;

	constructor(public brandService: BrandService) { }

	ngOnInit() { 
		let d = new Date();
    	this.currentYear = d.getFullYear();
	}
}
